import type { User } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getByEmail = (email: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, User>({
      method: 'GET',
      url: '/api/app/user',
      params: { email },
    },
    { apiName: this.apiName,...config });
}